document.addEventListener('DOMContentLoaded', function () {
  const modal = document.querySelector(
    '[data-freight-quote-modal]'
  );

  if (!modal) return;

  const dialog = modal.querySelector(
    '.bulk-freight-modal__dialog'
  );

  const closeButtons = modal.querySelectorAll(
    '[data-freight-modal-close]'
  );

  const summaryItems = modal.querySelector(
    '[data-freight-cart-items]'
  );

  const totalWeight = modal.querySelector(
    '[data-freight-total-weight]'
  );

  const subtotal = modal.querySelector(
    '[data-freight-subtotal]'
  );

  const cartDetailsField = modal.querySelector(
    '[data-freight-cart-details]'
  );

  const shopifyOrderField = modal.querySelector(
    '[data-freight-shopify-order]'
  );

  const form = modal.querySelector('form');

  const orderEndpoint =
    modal.dataset.freightOrderEndpoint ||
    '';

  let isSubmitting = false;


  /*
   * ------------------------------------------------------------
   * Money
   * ------------------------------------------------------------
   */

  function formatMoney(cents) {
    return new Intl.NumberFormat(
      'en-AU',
      {
        style: 'currency',
        currency: 'AUD'
      }
    ).format(cents / 100);
  }


  /*
   * ------------------------------------------------------------
   * Weight
   * ------------------------------------------------------------
   */

  function formatWeight(grams) {
    return (
      (grams / 1000)
        .toFixed(2)
        .replace(/\.00$/, '')
      + ' kg'
    );
  }


  /*
   * ------------------------------------------------------------
   * Get fresh Shopify cart
   * ------------------------------------------------------------
   */

  async function getCart() {
    const response = await fetch(
      '/cart.js',
      {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      }
    );

    if (!response.ok) {
      throw new Error(
        'Unable to load the current cart.'
      );
    }

    const cart =
      await response.json();

    if (
      !cart ||
      !Array.isArray(cart.items) ||
      cart.items.length === 0
    ) {
      throw new Error(
        'Your cart is empty.'
      );
    }

    return cart;
  }


  /*
   * ------------------------------------------------------------
   * Render cart
   * ------------------------------------------------------------
   */

  function renderCart(cart) {
    let itemsHtml = '';

    let detailsText = '';

    cart.items.forEach(
      function (item) {

        const itemWeight =
          item.grams *
          item.quantity;

        itemsHtml += `
          <div class="bulk-freight-cart-item">

            <div>
              <strong>
                ${escapeHtml(
                  item.product_title
                )}
              </strong>

              ${
                item.variant_title &&
                item.variant_title !==
                  'Default Title'
                  ? `
                    <div>
                      ${escapeHtml(
                        item.variant_title
                      )}
                    </div>
                  `
                  : ''
              }

              <div>
                Qty: ${item.quantity}
              </div>
            </div>

            <div>
              ${formatWeight(
                itemWeight
              )}
            </div>

          </div>
        `;

        detailsText +=
          `Product: ${item.product_title}\n` +
          `Variant: ${
            item.variant_title ||
            'Default'
          }\n` +
          `Variant ID: ${
            item.variant_id
          }\n` +
          `Quantity: ${
            item.quantity
          }\n` +
          `Weight: ${
            formatWeight(
              itemWeight
            )
          }\n\n`;
      }
    );

    if (summaryItems) {
      summaryItems.innerHTML =
        itemsHtml;
    }

    if (totalWeight) {
      totalWeight.textContent =
        formatWeight(
          cart.total_weight
        );
    }

    if (subtotal) {
      subtotal.textContent =
        formatMoney(
          cart.total_price
        );
    }

    detailsText +=
      `-------------------------\n` +
      `Total Cart Weight: ${
        formatWeight(
          cart.total_weight
        )
      }\n` +
      `Cart Subtotal: ${
        formatMoney(
          cart.total_price
        )
      }\n`;

    if (cartDetailsField) {
      cartDetailsField.value =
        detailsText;
    }
  }


  /*
   * ------------------------------------------------------------
   * Load cart into modal
   * ------------------------------------------------------------
   */

  async function loadCartData() {
    const cart =
      await getCart();

    renderCart(cart);

    return cart;
  }


  /*
   * ------------------------------------------------------------
   * Escape HTML
   * ------------------------------------------------------------
   */

  function escapeHtml(value) {
    const div =
      document.createElement('div');

    div.textContent =
      value == null
        ? ''
        : String(value);

    return div.innerHTML;
  }


  /*
   * ------------------------------------------------------------
   * Open modal
   * ------------------------------------------------------------
   */

  async function openModal() {
    modal.hidden = false;

    modal.setAttribute(
      'aria-hidden',
      'false'
    );

    document.documentElement.style.overflow =
      'hidden';

    document.body.style.overflow =
      'hidden';

    try {
      await loadCartData();
    } catch (error) {
      console.error(
        'Unable to load cart data:',
        error
      );
    }

    setTimeout(
      function () {
        const firstField =
          modal.querySelector(
            'input[name="contact[name]"]'
          );

        if (firstField) {
          firstField.focus();
        }
      },
      100
    );
  }


  /*
   * ------------------------------------------------------------
   * Close modal
   * ------------------------------------------------------------
   */

  function closeModal() {
    if (isSubmitting) {
      return;
    }

    modal.hidden = true;

    modal.setAttribute(
      'aria-hidden',
      'true'
    );

    document.documentElement.style.overflow =
      '';

    document.body.style.overflow =
      '';
  }


  /*
   * ------------------------------------------------------------
   * Successful native Shopify contact form submission
   * ------------------------------------------------------------
   */

  if (
    window.bulkFreightQuoteSuccess === true
  ) {
    modal.hidden = false;

    modal.setAttribute(
      'aria-hidden',
      'false'
    );

    document.documentElement.style.overflow =
      'hidden';

    document.body.style.overflow =
      'hidden';

    setTimeout(
      function () {
        const successMessage =
          modal.querySelector(
            '[data-freight-success]'
          );

        if (successMessage) {
          successMessage.focus();
        }
      },
      100
    );
  }


  /*
   * ------------------------------------------------------------
   * Open trigger
   * ------------------------------------------------------------
   */

  document.addEventListener(
    'click',
    function (event) {
      const trigger =
        event.target.closest(
          '[data-freight-quote-trigger]'
        );

      if (!trigger) {
        return;
      }

      event.preventDefault();

      openModal();
    }
  );


  /*
   * ------------------------------------------------------------
   * Close buttons
   * ------------------------------------------------------------
   */

  closeButtons.forEach(
    function (button) {
      button.addEventListener(
        'click',
        closeModal
      );
    }
  );


  /*
   * ------------------------------------------------------------
   * Escape key
   * ------------------------------------------------------------
   */

  document.addEventListener(
    'keydown',
    function (event) {
      if (
        event.key === 'Escape' &&
        !modal.hidden &&
        !isSubmitting
      ) {
        closeModal();
      }
    }
  );


  /*
   * ------------------------------------------------------------
   * Show form error
   * ------------------------------------------------------------
   */

  function showFormError(message) {
    let errorBox =
      form.querySelector(
        '[data-freight-api-error]'
      );

    if (!errorBox) {
      errorBox =
        document.createElement('div');

      errorBox.setAttribute(
        'data-freight-api-error',
        ''
      );

      errorBox.className =
        'form-errors';

      form.prepend(errorBox);
    }

    errorBox.textContent =
      message;

    errorBox.hidden = false;
  }


  /*
   * ------------------------------------------------------------
   * Clear form error
   * ------------------------------------------------------------
   */

  function clearFormError() {
    const errorBox =
      form.querySelector(
        '[data-freight-api-error]'
      );

    if (errorBox) {
      errorBox.remove();
    }
  }


  /*
   * ------------------------------------------------------------
   * Build Laravel payload
   * ------------------------------------------------------------
   */

  function buildPayload(cart) {
    const getField =
      function (selector) {
        const field =
          form.querySelector(
            selector
          );

        return field
          ? field.value.trim()
          : '';
      };

    return {

      name:
        getField(
          '#freight-name'
        ),

      email:
        getField(
          '#freight-email'
        ),

      phone:
        getField(
          '#freight-phone'
        ),

      suburb:
        getField(
          '#freight-suburb'
        ),

      delivery_address:
        getField(
          '#freight-address'
        ),

      state:
        getField(
          '#freight-state'
        ),

      postcode:
        getField(
          '#freight-postcode'
        ),

      delivery_notes:
        getField(
          '#freight-notes'
        ),

      cart: {

        items:
          cart.items.map(
            function (item) {
              return {

                variant_id:
                  String(
                    item.variant_id
                  ),

                quantity:
                  item.quantity,

                properties:
                  item.properties ||
                  {}
              };
            }
          ),

        total_weight_formatted:
          formatWeight(
            cart.total_weight
          ),

        subtotal_formatted:
          formatMoney(
            cart.total_price
          )
      }
    };
  }


  /*
   * ------------------------------------------------------------
   * Create Shopify Order
   * ------------------------------------------------------------
   */

  async function createFreightOrder(
    payload
  ) {
    if (!orderEndpoint) {
      throw new Error(
        'Freight order endpoint is not configured.'
      );
    }

    const response =
      await fetch(
        orderEndpoint,
        {
          method: 'POST',

          mode: 'cors',

          headers: {
            'Content-Type':
              'application/json',

            Accept:
              'application/json'
          },

          body:
            JSON.stringify(
              payload
            )
        }
      );

    let data = null;

    try {
      data =
        await response.json();
    } catch (error) {
      //
    }

    if (
      !response.ok ||
      !data ||
      data.success !== true
    ) {
      throw new Error(
        data?.message ||
        'Unable to create the freight order.'
      );
    }

    return data;
  }


  /*
   * ------------------------------------------------------------
   * Submit
   * ------------------------------------------------------------
   */

  if (form) {

    form.addEventListener(
      'submit',
      async function (event) {

        event.preventDefault();

        if (isSubmitting) {
          return;
        }


        /*
         * Native validation
         */

        if (
          !form.reportValidity()
        ) {
          return;
        }


        isSubmitting = true;

        clearFormError();


        const submitButton =
          form.querySelector(
            'button[type="submit"]'
          );

        const originalButtonText =
          submitButton
            ? submitButton.textContent
            : 'Submit Freight Quote Request';

        if (submitButton) {
          submitButton.disabled = true;

          submitButton.textContent =
            'Creating Freight Order...';
        }


        try {

          /*
           * Always load a fresh cart
           * immediately before order creation.
           */

          const cart =
            await loadCartData();


          /*
           * Build request payload
           */

          const payload =
            buildPayload(
              cart
            );


          /*
           * Create real Shopify order
           */

          const result =
            await createFreightOrder(
              payload
            );


          /*
           * Add order reference
           * to existing Shopify email.
           */

          if (
            shopifyOrderField
          ) {
            shopifyOrderField.value =
              result.order_name ||
              result.order_id ||
              'Created';
          }


          /*
           * Update hidden email details
           * one final time.
           */

          if (
            cartDetailsField
          ) {
            cartDetailsField.value +=
              `\nShopify Freight Order: ${
                result.order_name ||
                result.order_id ||
                'Created'
              }\n`;
          }


          /*
           * Existing Shopify contact form
           *
           * This keeps your current email
           * workflow unchanged.
           */

          if (submitButton) {
            submitButton.textContent =
              'Sending Freight Request...';
          }


          /*
           * Native submit bypasses this
           * JavaScript submit listener.
           */

          HTMLFormElement.prototype.submit.call(
            form
          );

        } catch (error) {

          console.error(
            'Freight quote submission failed:',
            error
          );

          showFormError(
            error.message ||
            'Something went wrong while creating your freight request. Please try again.'
          );

          isSubmitting = false;

          if (submitButton) {
            submitButton.disabled = false;

            submitButton.textContent =
              originalButtonText;
          }
        }
      }
    );
  }
});